import { mapPage } from "@/core/mapping";

export function mapSales(response) {
    return mapPage(response, {
        id: "id",
        name: "name",
        slug: "slug",
        coupon: "coupon",
    });
}

export function mapSaleProducts(response) {
    return mapPage(response, {
        id: "id",
        discountPercent: "discountPercent",
        product: "product",
    });
}
